import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';

import { HugeiconsIconComponent } from '@hugeicons/angular';
import { ViewIcon, ViewOffIcon } from '@hugeicons/core-free-icons';
import { AuthService } from '../../../core/services/auth.service';
import { SnackbarService } from '../../../core/services/snackbar.service';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, RouterLink, HugeiconsIconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  showPassword = false;
  isLoading = false;
  errorMessage = ''; // Keeping this for backward compatibility if needed, but we'll use snackbar
  
  viewIcon = ViewIcon;
  viewOffIcon = ViewOffIcon;

  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    rememberMe: new FormControl(false)
  });

  constructor(
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private router: Router
  ) { }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';

      const credentials = {
        email: this.loginForm.value.email!,
        password: this.loginForm.value.password!
      };

      this.authService.login(credentials).subscribe({
        next: (response) => {
          this.snackbarService.showSuccess('Login successful! Welcome back.');
          this.isLoading = false;
          if (response.role === 'ASSISTANT') {
            this.router.navigate(['/assistant-cases']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        },
        error: (error) => {
          this.isLoading = false;

          let message = 'An error occurred during login. Please try again.';

          if (error.error) {
            if (typeof error.error === 'string') {
              message = error.error;
            } else if (error.error.message) {
              message = error.error.message;
            } else if (error.error.errors) {
              const validationErrors = error.error.errors;
              const firstErrorKey = Object.keys(validationErrors)[0];
              message = validationErrors[firstErrorKey][0];
            }
          } else {
            message = 'Unable to connect to the server. Please check your internet connection.';
          }

          this.snackbarService.showError(message);
        }
      });
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.loginForm.controls).forEach(key => {
        this.loginForm.get(key)?.markAsTouched();
      });
    }
  }
}
